/** Step-complete fanfare: confetti burst + optional two-note chime (SC-20b). */

const CONFETTI_COLORS = ["#6366f1", "#22c55e", "#f59e0b", "#ec4899", "#06b6d4", "#a855f7"];

function ensureConfettiKeyframes() {
  if (typeof document === "undefined") return;
  if (document.getElementById("eduviaos-roadmap-confetti-keyframes")) return;
  const style = document.createElement("style");
  style.id = "eduviaos-roadmap-confetti-keyframes";
  style.textContent = `@keyframes eduviaos-roadmap-confetti {
    0% { transform: translate(-50%, -50%) rotate(0deg) scale(1); opacity: 1; }
    100% { transform: translate(var(--tx, 0px), var(--ty, 140px)) rotate(var(--rot, 360deg)) scale(0.6); opacity: 0; }
  }`;
  document.head.appendChild(style);
}

export function burstRoadmapConfetti(reduceMotion: boolean, intensity: "light" | "full" = "full") {
  if (reduceMotion || typeof document === "undefined") return;
  ensureConfettiKeyframes();
  const count = intensity === "full" ? 42 : 18;
  for (let i = 0; i < count; i += 1) {
    const piece = document.createElement("span");
    piece.setAttribute("aria-hidden", "true");
    const tx = `${(Math.random() > 0.5 ? 1 : -1) * (30 + Math.random() * 120)}px`;
    const ty = `${80 + Math.random() * 180}px`;
    const rot = `${180 + Math.random() * 540}deg`;
    piece.style.cssText = [
      "position:fixed",
      "pointer-events:none",
      "z-index:9999",
      `width:${6 + Math.random() * 6}px`,
      `height:${8 + Math.random() * 10}px`,
      "border-radius:2px",
      `background:${CONFETTI_COLORS[i % CONFETTI_COLORS.length]}`,
      `left:${38 + Math.random() * 24}%`,
      "top:42%",
      "opacity:0.95",
      "transform:translate(-50%,-50%)",
      "animation:eduviaos-roadmap-confetti 1100ms ease-out forwards",
      `animation-delay:${Math.random() * 180}ms`,
      `--tx:${tx}`,
      `--ty:${ty}`,
      `--rot:${rot}`,
    ].join(";");
    document.body.appendChild(piece);
    window.setTimeout(() => piece.remove(), 1300);
  }
}

export function playStepFanfare(reduceMotion: boolean) {
  if (reduceMotion || typeof window === "undefined") return;
  try {
    const ctx = new AudioContext();
    const notes = [523.25, 659.25, 783.99];
    notes.forEach((freq, i) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.type = "sine";
      osc.frequency.value = freq;
      const start = ctx.currentTime + i * 0.09;
      gain.gain.setValueAtTime(0.0001, start);
      gain.gain.exponentialRampToValueAtTime(0.045, start + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, start + 0.28);
      osc.start(start);
      osc.stop(start + 0.3);
    });
  } catch {
    // Audio optional
  }
}

export function celebrateStepComplete(reduceMotion: boolean) {
  burstRoadmapConfetti(reduceMotion, "full");
  playStepFanfare(reduceMotion);
}
